<template>
    <div>
        <div class="row" style="margin-bottom:20px">
            <div class="col-md-9" style="padding:14px;padding-top:11px">
               <!-- Generato da claude — Società card: split layout, logo a destra nascosto su mobile -->
                <div class="card"  v-if="negozio.ID_NEGOZIO > 0">
                    <div class="card-header card-header-background">
                        <span class="dk-header-title"><i class="fa-fw fal fa-store-alt me-1"></i> Società</span>
                    </div>
                    <div class="card-body">
                        <div class="d-flex align-items-center gap-4">
                            <div class="flex-grow-1">
                                <div class="fw-bold mb-1" style="font-size:1.1rem">{{negozio.ALIAS}}</div>
                                <div class="text-muted mb-1" style="font-size:.9rem">
                                    <i class="fal fa-map-marker-alt fa-fw"></i> {{negozio.INDIRIZZO}} – {{negozio.comune.NOME}}
                                </div>
                                <div class="text-muted mb-1" style="font-size:.9rem">
                                    <i class="fal fa-phone fa-fw"></i> {{negozio.TELEFONO}}
                                </div>
                                <div class="text-muted" style="font-size:.9rem">
                                    <i class="fal fa-credit-card fa-fw"></i>
                                    {{negozio.ACCETTA_PAGAMENTI_ONLINE == 1 ? 'Accetta' : 'NON accetta'}} pagamenti online
                                </div>
                            </div>
                            <div class="d-none d-md-flex flex-shrink-0 align-items-center justify-content-end" style="min-width:160px">
                                <img :src="'https://gestionale.assosprint.it/CORE/SERVER/UPLOAD/IMG/LOGHI/'+ negozio.URL_LOGO"
                                    style="max-height:90px; max-width:160px; object-fit:contain"
                                    alt="logo negozio">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" >
                    <div class="card-header card-header-background">
                        <span class="dk-header-title"><i class="fa-fw fal fa-euro-sign me-1"></i> Prodotti</span>
                        <div class="ms-auto" style="max-width:220px">
                            <input type="text" class="form-control form-control-sm"
                                v-model="search.DESCRIZIONE.VALUE"
                                placeholder="Ricerca"
                                autocomplete="off">
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="dk-list-item"
                            v-for="prodotto in paginatedList.arr"
                            :key="prodotto.ID_PRODOTTO"
                            v-show="prodotto.FK_ID_TIPO == 1">
                            <div class="dk-list-info">
                                <div class="dk-list-title">{{prodotto.DESCRIZIONE}}</div>
                                <div class="dk-list-sub">€ {{prodotto.PREZZO_UNITARIO}}</div>
                            </div>
                            <div class="dk-list-action">
                                <button @click="addToCart(prodotto)" class="btn btn-sm btn-dk-orange">
                                    <i class="fal fa-cart-plus fa-fw"></i> Aggiungi
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-md-3">
                <Carrello :ref="'carrello'" :modalita="1" :noq="1"></Carrello>
                <button class="btn btn-warning btn btn-lg btn-block" style="margin-top:10px" v-on:click="checkOut()"><i class="fal fa-fw fa-euro-sign"></i>Checkout</button>
            </div>
        </div>


        <div class="modal fade" id="popUpSocioQuotaPeriodica"  role="dialog"  aria-modal="true" >
            <div class="modal-dialog" style="max-width:574px"  >
                <div class="modal-content" >
                    <div class="modal-header modal-header-info">
                        <h5 class="modal-title">Seleziona MESI</h5>
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <div class="modal-body">
                        <h4>Seleziona i mesi per i quali stai effettuando il pagamento</h4>
                        <h5>Socio: {{$root.getSocio($root.DESKALO_SOCIO_SELEZIONATO.ID_SOCIO,$root.DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).COGNOME}} {{$root.getSocio($root.DESKALO_SOCIO_SELEZIONATO.ID_SOCIO,$root.DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).NOME}}</h5>
                        <h5>Quota: {{prodottoSelezionato.DESCRIZIONE}}</h5>
                        <hr/>
                        <div class="row">
                            <div class="col-md-4" v-for="mese in arrayMesi" style="margin-bottom:10px" v-on:click="selezionaMese(mese)" v-bind:key="mese">
                                <div style="border: 1px solid #ccc;padding: 10px;border-radius: 6px;text-align: center;" class="lift-panel" v-bind:style="getStileMese(mese)">
                                    {{mese.MESE}}/{{mese.ANNO}}                            
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-success btn-lg btn-block" v-on:click="addQuotaPeriodica()">Conferma</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="popUpSocioScadenzario"  role="dialog"  aria-modal="true" >
            <div class="modal-dialog" style="max-width:574px"  >
                <div class="modal-content" >
                    <div class="modal-header modal-header-info">
                        <h5 class="modal-title">Seleziona rata</h5>
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <div class="modal-body">
                        <h4>Seleziona la rata di cui intendi effettuare il pagamento</h4>
                        <h5>Socio: {{$root.getSocio($root.DESKALO_SOCIO_SELEZIONATO.ID_SOCIO,$root.DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).COGNOME}} {{$root.getSocio($root.DESKALO_SOCIO_SELEZIONATO.ID_SOCIO,$root.DESKALO_SOCIO_SELEZIONATO.ID_NEGOZIO).NOME}}</h5>
                        <h5>Quota: {{prodottoSelezionato.DESCRIZIONE}}</h5>
                        <hr/>
                        <div class="row">
                            <div class="col-md-12" v-for="rata in arrayRateScadenzario" style="margin-bottom:10px" v-bind:key="rata.ID_RATA" v-on:click="selezionaRata(rata)">
                                <div style="border: 1px solid #ccc;padding: 10px;border-radius: 6px;text-align: center;" class="lift-panel" v-bind:style="getStileRata(rata)">
                                    {{rata.DESCRIZIONE}} - € {{filters.formattaImporto(rata.IMPORTO)}} - Scadenza {{filters.formatDate(rata.DATA_SCADENZA)}}
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-success btn-lg btn-block" v-on:click="addQuotaScadenzario()">Conferma</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Carrello from '@/components/common/Carrello.vue'


export default {
    name:"Shop",
    components:{
        Carrello
    },
    data:function(){
        return{
            filters:global.filters,
            arrayProdotti : new Array(),
            negozio : {},
            arraySoci : new Array(),
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:200},
                DESCRIZIONE:{TYPE:'TEXT',VALUE:''},
            },
            prodottoSelezionato:{},
            prodottoAsSelezionato : {},
            arrayMesi : new Array(),
            arrayMesiSelezionati : new Array(),
            arrayRateScadenzario : new Array(),
            rataScadenzarioSelezionata : {},
            arrayAttivita : new Array()
        }
    },
    methods: {
        getProdotti : function(){
            utils.ajax('ec/negozio/prodotti',{ID_NEGOZIO:this.negozio.ID_NEGOZIO}, (response) => {
                this.arrayProdotti = response.data;
            });
        },
        getImmagineSfondo : function(prodotto){
            var url = 'CORE/UPLOAD/PRODOTTI/'+ prodotto.URL_IMMAGINE;
            return {
                "background-image": "url('"+ url +"')",
                "background-position":"center",
                "background-repeat":"no-repeat",
                "background-size":"cover",    
            }
        },
        addToCart : function(prodotto){
            this.prodottoSelezionato = utils.clone(prodotto);
            utils.ajax('/deskalo/prodotto/pre/add',{ID_PRODOTTO:this.prodottoSelezionato.ID_PRODOTTO,QUANTITA:1}, (response) => {
                if (response.esito == 0){
                    if (response.data.ESITO == 0){
                        if (response.data.NEEDS_ACTION == 1){
                            this.prodottoAsSelezionato = response.data.PRODOTTO_AS;
                            //QUOTA PERIODICA
                            if (this.prodottoAsSelezionato.FK_ID_TIPO == 2){
                                this.arrayMesiSelezionati = new Array();
                                this.arrayMesi = response.data.ARRAY_MESI;
                                var modal = $('#popUpSocioQuotaPeriodica');
                                modal.modal('show');
                            }
                            else if (this.prodottoAsSelezionato.FK_ID_TIPO == 6){
                                this.rataScadenzarioSelezionata = {};
                                this.arrayRateScadenzario = response.data.RATE;
                                var modal = $('#popUpSocioScadenzario');
                                modal.modal('show');
                            }
                        }
                        else{
                            this.doAddToCart({});
                        }
                    }
                    else{
                        utils.alert.warning(response.data.MESSAGGIO);
                    }
                }
            });
        },

        addQuotaPeriodica : function(){
            if (this.arrayMesiSelezionati.length > 0){
                var opzioni = {
                    arrayMesi : this.arrayMesiSelezionati
                }
                var modal = $('#popUpSocioQuotaPeriodica');
                modal.modal('hide');
                this.doAddToCart(opzioni);
            }
            else{
                alert("Selezionare i mesi necessari")
            }
        },
        addQuotaScadenzario : function(){
            if (this.rataScadenzarioSelezionata.ID_RATA > 0){
                var opzioni = {
                    rata : this.rataScadenzarioSelezionata
                }
                var modal = $('#popUpSocioScadenzario');
                modal.modal('hide');
                this.doAddToCart(opzioni);                
            }
            else{
                alert("Selezionare almeno una rata");
            }
        },
        doAddToCart : function(opzioni){
            utils.ajax('/deskalo/carrello/prodotto/add',{ID_PRODOTTO:this.prodottoSelezionato.ID_PRODOTTO,QUANTITA:1,OPTIONS:opzioni}, (response) => {
                if (response.esito == 0){
                    this.$refs.carrello.setCarrello(response.data);
                }
            });
        },
        checkOut : function(){
            global.router.push("Checkout");
        },
        selezionaMese : function(mese){
            if (this.arrayMesiSelezionati.length == this.prodottoAsSelezionato.QP_NUMERO_MESI){
                return;
            }
            for (var i = 0 ; i < this.arrayMesiSelezionati.length ; i++){
                if (this.arrayMesiSelezionati[i].ANNO == mese.ANNO && this.arrayMesiSelezionati[i].MESE == mese.MESE){
                    this.arrayMesiSelezionati.splice(i,1);
                    return;
                }
            }
            this.arrayMesiSelezionati.push(mese);
        },
        selezionaRata : function(rata){
            if (this.rataScadenzarioSelezionata.ID_RATA == rata.ID_RATA){
                this.rataScadenzarioSelezionata = {};
            }
            else{
                this.rataScadenzarioSelezionata = utils.clone(rata);
            }
        },
        getStileMese : function(mese){
            for (var i = 0 ; i < this.arrayMesiSelezionati.length ; i++){
                if (this.arrayMesiSelezionati[i].ANNO == mese.ANNO && this.arrayMesiSelezionati[i].MESE == mese.MESE){
                    return {background:'#1cc88a'};
                }
            }
            if (this.arrayMesiSelezionati.length == this.prodottoAsSelezionato.QP_NUMERO_MESI){
                return {background:'#eee'};
            }
            return {};
        },
        getStileRata : function(rata){
            if (rata.ID_RATA == this.rataScadenzarioSelezionata.ID_RATA){
                return {background:'#1cc88a'};
            }
            return {background:'#eee'};
        },
        getLblOra : function(oraInt){
            var s = "";
            var ora =  Math.floor(oraInt/12);
            var minuto = oraInt % 12 ;
            minuto = minuto*5;
            return (ora > 9 ? ora : "0" + ora.toString()) + ":" + (minuto > 9 ? minuto : "0" + minuto.toString());
        },
      
    },
    computed: {
        paginatedList(){
            console.log(this.arrayProdotti);
            if (this.arrayProdotti.length == 0 || this.arrayProdotti == null || this.arrayProdotti == undefined)
                return {count:0,arr:new Array()};
            var arr = utils.inGrid(this.arrayProdotti,this.search);
            return arr;
        },
    },
    created : function() {
        utils.ajax('/deskalo/spesa/startup',{}, (response) => {
            this.negozio = response.data.NEGOZIO;
            this.arrayAttivita = response.data.ATTIVITA;
            this.arrayProdotti = this.negozio.prodottiAbilitati;
        });
    },
}
</script>